import { defineStore } from "pinia";

export const useCourseStore = defineStore("course-store", {
  state: () => ({
    isCreateCourseModalOpen: false,
    isCreatingCourse: false,
    isCreateLessonModalOpen: false,
    isCreatingLesson: false,
    error: null,
    course: [],
  }),

  getters: {
    courseId() {
      return this.course.course_id;
    },
  },

  actions: {
    openCreateCourseModal() {
      this.isCreateCourseModalOpen = true;
    },

    closeCreateCourseModal() {
      this.isCreateCourseModalOpen = false;
    },

    openCreateLessonModal() {
      this.isCreateLessonModalOpen = true;
    },

    closeCreateLessonModal() {
      this.isCreateLessonModalOpen = false;
    },

    createCourse(name, publicationId, price, numberOfLessons) {
      this.isCreatingCourse = true;
      this.error = null;

      this.apiPost(
        "/courses",
        {
          name,
          publication_id: publicationId,
          price,
          number_of_lessons: numberOfLessons,
        },
        data => {
          window.location.href = `/stories/editor?story_id=${data.course.story_id}`;
        },
        () => {
          this.error = "Could not create course. Please try again";
        },
        () => {
          this.isCreatingCourse = false;
        },
      );
    },

    createLesson(name, courseId) {
      this.isCreatingLesson = true;
      this.error = null;

      this.apiPost(
        `/courses/${courseId}/lesson`,
        {
          name,
        },
        data => {
          window.location.href = `/stories/editor?story_id=${data.lesson.story_id}`;
        },
        () => {
          this.error = "Could not create lesson. Please try again";
        },
        () => {
          this.isCreatingLesson = false;
        },
      );
    },
  },
});
